import { SessionTimeoutService } from '../../services/session-timeout.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Component, Inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-logout-popup',
    templateUrl: './logout-popup.component.html',
    styleUrls: ['./logout-popup.component.css'],
    standalone: true,
    imports: [MatButtonModule, MatCardModule]
})

export class LogoutPopupComponent implements OnInit {
    countdown: number = 15;
    autoLoggedOut: boolean = false;
    private countdownInterval: any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { message: string },
        private dialogRef: MatDialogRef<LogoutPopupComponent>,
        private sessionTimeoutService: SessionTimeoutService
    ) { }

    ngOnInit(): void {
        this.startCountdown();
    }

    private startCountdown(): void {
        this.countdownInterval = setInterval(() => {
            this.countdown--;

            if (this.countdown <= 0) {
                this.autoLoggedOut = true;
                clearInterval(this.countdownInterval);
                this.confirmLogout();
            }
        }, 1000);
    }

    keepSignedIn(): void {
        clearInterval(this.countdownInterval);
        this.dialogRef.close(false);
    }

    confirmLogout(): void {
        clearInterval(this.countdownInterval);
        this.dialogRef.close(true);
        this.sessionTimeoutService.performLogout();
    }
}
